import * as ActiveStorage from '@rails/activestorage'
import { createRoot } from 'react-dom/client'
import React from 'react'
import App from '../App'

ActiveStorage.start()

document.addEventListener('DOMContentLoaded', () => {
  const container = document.body.appendChild(document.createElement('div'))
  createRoot(container).render(<App/>)
})

